import { render } from "./DashboardsSubview.vue?vue&type=template&id=17df824c&scoped=true"
import script from "./DashboardsSubview.vue?vue&type=script&lang=js"
export * from "./DashboardsSubview.vue?vue&type=script&lang=js"

import "./DashboardsSubview.vue?vue&type=style&index=0&id=17df824c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17df824c"]])

export default __exports__